/**
 * Webpack UMD externals map react/jsx-runtime → window.React.
 * Official React UMD builds do not expose React.jsx / React.jsxs; SWP pages
 * still work because most siteglass code paths use createElement, but newer
 * @ux/* CJS builds call jsx(). Patch those helpers onto the global.
 */
function patchJsxRuntime(React) {
  if (!React || typeof React.createElement !== 'function') {
    if (typeof console !== 'undefined') {
      console.error('[jsx-shim] React is missing; load react UMD first');
    }
    return;
  }
  if (typeof React.jsx === 'function') {
    return;
  }

  function jsx(type, config, maybeKey) {
    var props = {};
    var key = maybeKey !== undefined && maybeKey !== null ? '' + maybeKey : null;

    if (config != null) {
      for (var propName in config) {
        if (!Object.prototype.hasOwnProperty.call(config, propName)) continue;
        if (propName === 'key') {
          if (config.key !== undefined && config.key !== null) {
            key = '' + config.key;
          }
          continue;
        }
        if (propName === '__self' || propName === '__source') continue;
        props[propName] = config[propName];
      }
    }

    if (key !== null) {
      props.key = key;
    }

    return React.createElement(type, props);
  }

  React.jsx = jsx;
  React.jsxs = jsx;
  React.jsxDEV = jsx;
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { patchJsxRuntime };
}

// Browser script: /assets/jsx-shim.js (UMD React already on window)
if (typeof window !== 'undefined' && window.React) {
  patchJsxRuntime(window.React);
}
